import { tk, verticalGap } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';
import { ScoreBars } from './ScoreBars';
import { Categories } from './Categories';
import { Rating } from './Rating';
import { MostBookedByLabel } from './MostBookedByLabel';

const Wrapper = styled.div`
  ${verticalGap('spacing_lg')}

  @media ${tk('mq_desktop_md')} {
    padding-right: 80px;
  }
`;

const MostBookedByLabelWrapper = styled.div`
  display: none;

  @media ${tk('mq_desktop_md')} {
    display: block;
  }
`;

export function Overview() {
  return (
    <Wrapper>
      <Rating />
      <ScoreBars />
      <MostBookedByLabelWrapper>
        <MostBookedByLabel />
      </MostBookedByLabelWrapper>
      <Categories />
    </Wrapper>
  );
}

Overview.Wrapper = Wrapper;
